<div class="d-flex justify-content-center ml-4 mr-4 mt-1 mb-1 flex-nowrap">
  <h3 class="colorednavbar-top mb-0" data-cy="module-title"><strong>{{'APPLICATION.SFK-MODUL'|translate}}</strong></h3>
</div>
<nav class="navbar navbar-expand-lg navbar-dark mb-3 colorednavbar py-3 h5 fw-bold">
  <div class="container-fluid">
    <div class="navbar-brand">
      <img
        id="logo"
        [src]="this.safeLogoSource"
        alt="logo"
        style="max-height: var(--logo-height, 50px)"
        data-cy="customer-logo"
        >
      </div>
      <button class="navbar-toggler" style="margin-right:5px !important;" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
        data-cy="nav-hamburger"
        >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent" data-cy="navbar-collapsible">
        <ul class="navbar-nav mr-auto">

          <!--        Home-->
          @if (roleEnabled['Antragsteller']) {
            <li class="nav-item">
              <a class="nav-link textnavbar" [routerLink]="['/pages/home']" data-cy="nav-home">
                <fa-icon class="homeIcon" [icon]="faHouse"></fa-icon>
              </a>
            </li>
          }

          <!--        Ticketanträge-->
          @if (roleEnabled['Antragsteller'] && moduleEnabled['antragTicket']) {
            <li class="nav-item"
              data-cy="nav-item-antraege">
              <a class="nav-link textnavbar"
                [routerLink]="['/pages/ticket-table']"
                data-cy="nav-item-antraege-link"
                >
                {{existsSessionStorageTextbausteine?
                textbausteinService.printTextbausteinByKey( KeyString.ANTRAEGE_VERWALTEN_MENUE, ('HOME.LINK_TICKET_TABLE'|translate) ):('HOME.LINK_TICKET_TABLE'|translate)}}
              </a>
            </li>
          }

          <!--        Fahrkosten Erstattungen-->
          @if (roleEnabled['Antragsteller'] && moduleEnabled['fahrkosten']) {
            <li class="nav-item"
              data-cy="nav-item-fahrkosten">
              <a class="nav-link textnavbar"
                [routerLink]="['/pages/fahrkosten']"
                data-cy="nav-item-fahrkosten-link"
                >
                {{existsSessionStorageTextbausteine?
                textbausteinService.printTextbausteinByKey( KeyString.FAHRKOSTEN_VERWALTEN_MENUE, ('HOME.LINK_FAHRKOSTEN_TABLE'|translate) ):('HOME.LINK_FAHRKOSTEN_TABLE'|translate)}}
              </a>
            </li>
          }

          <!--        Tickets-->
          @if(moduleEnabled['studentTickets']) {
            @if (roleEnabled['Antragsteller']) {
              <li class="nav-item"
                data-cy="nav-item-student-tickets">
                <a class="nav-link textnavbar" [routerLink]="['/pages/tickets']"
                  data-cy="nav-item-tickets-link">{{existsSessionStorageTextbausteine?
                  textbausteinService.printTextbausteinByKey( KeyString.LINK_TICKETS_MENUE, ('HOME.LINK_TICKETS'|translate) ):('HOME.LINK_TICKETS'|translate)}}
                </a>
              </li>
            }
          }

          <!--        Schueler-->
          @if (roleEnabled['Antragsteller']) {
            <li class="nav-item"
              data-cy="nav-item-schueler">
              <a class="nav-link textnavbar" [routerLink]="['/pages/schueler-table']"
                data-cy="nav-item-schueler-link">
                {{existsSessionStorageTextbausteine?
                textbausteinService.printTextbausteinByKey( KeyString.SCHUELER_VERWALTEN_MENUE, ('HOME.LINK_SCHUELER_TABLE'|translate) ):('HOME.LINK_SCHUELER_TABLE'|translate)}}
              </a>
            </li>
          }
        </ul>

        <ul class="navbar-nav ms-auto">
          <li class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
            @if (configService.featureConfig.kommunalportalAuth) {
              <div data-cy="username-portal" class="d-inline-block">
                <p class="nav-link textnavbar" id="antragsteller-name">
                  {{benutzer?.vorname}} {{benutzer?.name}}
                </p>
              </div>
            }
            @if (configService.featureConfig.jwtAuth) {
              <div data-cy="username-jwt" class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
                <a class="nav-link textnavbar" id="dropdownBasic1" ngbDropdownToggle>
                  <ng-container id="antragsteller-name">
                    {{benutzer?.vorname}} {{benutzer?.name}}
                  </ng-container>
                </a>
                <div ngbDropdownMenu class="custom-dropdown-menu" aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem [routerLink]="['/pages/profil']">
                    <fa-icon class="me-1" [icon]="faProfil"></fa-icon>
                    {{'APPLICATION.MAIN.PROFIL'|translate}}
                  </button>
                  <button ngbDropdownItem [routerLink]="['/pages/account']">
                    <fa-icon class="me-1" [icon]="faAccount"></fa-icon>
                    {{'APPLICATION.MAIN.ACCOUNT'|translate}}
                  </button>
                  <hr class="mb-1 mt-1">
                  <button
                    ngbDropdownItem
                    (click)="logout()"
                    data-cy="profile-logout"
                    >
                    <fa-icon class="me-1" [icon]="faAbmelden"></fa-icon>
                    {{'APPLICATION.MAIN.ABMELDEN'|translate}}
                  </button>
                </div>
              </div>
            }
          </li>

          <li class="nav-item">
            <a class="nav-link disabled" href="#">
              <app-countdown
                [endDateObservable$]="this.endDateForLogout$"
                [loggedoutMessageVisible$]="this.loggedoutMessageVisible$"
                id="countdown_component"
                data-cy="countdown-component"
              ></app-countdown>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
